export var DocumentoAquisicaoEnum;
(function (DocumentoAquisicaoEnum) {
    DocumentoAquisicaoEnum["CONTRATO_PART_COMPRA_VENDA"] = "CONTRATO_PART_COMPRA_VENDA";
    DocumentoAquisicaoEnum["ESCRITURA_PUBLICA_DEC_POSSE"] = "ESCRITURA_PUBLICA_DEC_POSSE";
    DocumentoAquisicaoEnum["DECLARACAO_OCUPACAO"] = "DECLARACAO_OCUPACAO";
    DocumentoAquisicaoEnum["OUTROS"] = "OUTROS";
})(DocumentoAquisicaoEnum || (DocumentoAquisicaoEnum = {}));
(function (DocumentoAquisicaoEnum) {
    var mapDescricao = new Map([
        [DocumentoAquisicaoEnum.CONTRATO_PART_COMPRA_VENDA, 'Escritura/Contrato Particular de compra e venda'],
        [DocumentoAquisicaoEnum.ESCRITURA_PUBLICA_DEC_POSSE, 'Escritura Pública Declaratória de Posse'],
        [DocumentoAquisicaoEnum.DECLARACAO_OCUPACAO, 'Declaração de Ocupação '],
        [DocumentoAquisicaoEnum.OUTROS, 'Outros'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    DocumentoAquisicaoEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    DocumentoAquisicaoEnum.getOptions = getOptions;
})(DocumentoAquisicaoEnum || (DocumentoAquisicaoEnum = {}));
